export const CONTRACTUAL_CATEGORIES = [
  {
    description: 'Dipendente a tempo indeterminato',
    value: 'tempo-indeterminato',
    type: 'PRIVATE',
    secondaryType: 'PRIVATE',
    requiredData: {
      pi: false,
      rs: false
    }
  },
  {
    description: 'Ditta individuale',
    value: 'ditta-individuale',
    type: 'BUSINESS',
    secondaryType: 'PRIVATE',
    requiredData: {
      pi: true,
      rs: true
    }
  },
  {
    description: 'Libero professionista',
    value: 'libero-professionista',
    type: 'BUSINESS',
    secondaryType: 'PRIVATE',
    requiredData: {
      pi: true,
      rs: true
    }
  },
  {
    description: 'Pensionato',
    value: 'pensionato',
    type: 'PRIVATE',
    secondaryType: 'PRIVATE',
    requiredData: {
      pi: false,
      rs: false
    }
  },
  {
    description: 'Società di capitali (S.p.a. - S.r.l. - S.r.l.s. - S.a.p.a. - Cooperative)',
    value: 'societa-capitale',
    type: 'BUSINESS',
    secondaryType: 'BUSINESS',
    requiredData: {
      pi: true,
      rs: true
    }
  },
  {
    description: 'Società di persone (S.s. - S.n.c. - S.a.s.)',
    value: 'societa-persone',
    type: 'BUSINESS',
    secondaryType: 'BUSINESS',
    requiredData: {
      pi: true,
      rs: true
    }
  },
  {
    description:
      'Associazioni - Enti - Fondazioni',
    value: 'associazioni-enti-fondazioni',
    type: 'BUSINESS',
    secondaryType: 'BUSINESS',
    requiredData: {
      pi: true,
      rs: true
    }
  },
  {
    description: 'Studi Associati',
    value: 'studi-associati',
    type: 'BUSINESS',
    secondaryType: 'BUSINESS',
    requiredData: {
      pi: true,
      rs: true
    }
  },
];
